// git hash 8ee6b172772eecafce6aa2c5c0f974c689aeb397
export default {
  'editionSettings': {
    'key': 'espn-es-es',
    'site': 'espn',
    'language': 'es',
    'country': 'es',
    'domain': 'www.espn.com',
    'editionSiteId': '1',
    'https': false,
    'supportsOneSite': true
  },
  'navId': '3462114',
  'dictionarySection': 'espn',
  'javaLocale': {
    'language': 'es',
    'region': 'MX'
  },
  'dateTime': {
    'long': 'dddd MMMM d, yyyy',
    'medium': 'MMMM d, yyyy',
    'short': 'M/d',
    'timeFormat': 'h:mm',
    'firstDayOfWeek': 'Sunday',
    'timeZone': 'America/Santiago',
    'defaultFormat': 'd MMM, yyyy',
    'timeZoneString': 'CT',
    'timeZoneBucket': 'America/New_York',
    'MMM D, YYYY': 'D MMM, YYYY',
    'M/D/YYYY': 'D/M/YYYY',
    'MM/DD/YYYY': 'DD/MM/YYYY',
    'MMDDYYYY': 'DDMMYYYY',
    'MMMM Do YYYY': 'Do MMMM YYYY',
    'dddd, MMMM Do YYYY': 'dddd, Do MMMM YYYY',
    'ddd, MMM D YYYY': 'ddd, D MMM YYYY',
    'M/D': 'D/M',
    'MMMM D, YYYY': 'D MMMM YYYY',
    'dddd, M/D': 'dddd, D/M',
    'age': {
      'seconds': 's',
      'minutes': 'm',
      'hours': 'h',
      'days': 'd'
    }
  },
  'numberFormat': {
    'long': '#,###',
    'short': '###',
    'currency': '#,###.00',
    'percent': '#.00%'
  },
  'temperature': {
    'scale': 'celsius',
    'symbol': '&deg; C'
  },
  'outbrain': {
    'enabled': true,
    'template': 'ESPNDeportesLATAM',
    'desktop': {
      'compliantId': 'AR_2',
      'nonCompliantId': 'AR_4'
    },
    'mobile': {
      'compliantId': 'MB_2',
      'nonCompliantId': 'MB_6'
    },
    'video': {
      'desktop': {
        'compliantId': 'AR_16'
      },
      'mobile': {
        'compliantId': 'MB_6'
      }
    },
    'report': {
      'desktop': {
        'compliantId': 'AR_30',
        'nonCompliantId': 'AR_30'
      },
      'mobile': {
        'compliantId': 'MB_9',
        'nonCompliantId': 'MB_9'
      }
    },
    'table': {
      'desktop': {
        'compliantId': 'AR_43'
      },
      'mobile': {
        'compliantId': 'MB_43'
      }
    },
    'game': {
      'desktop': {
        'compliantId': 'AR_48'
      },
      'mobile': {
        'compliantId': 'AR_48'
      }
    }
  },
  'omniture': {
    'enabled': true
  },
  'chartBeat': {
    'enabled': true
  },
  'ads': {
    'disabled': false,
    'network': 1234,
    'partnerAd': false,
    'dev-config': 14005378,
    'qa-config': 14005378,
    'prod-config': 14005378,
    'outputType': 'js',
    'featurePhone': {
      'outputType': 'no-js'
    }
  },
  'partnerModules': {
    'global': false,
    'nba': false,
    'womenbb': false,
    'golf': false,
    'endurance': false,
    'horse': false,
    'nascar': false
  },
  'sportBranding': [ {
    'sport': 'cricket',
    'image': 'logo-uk-cricinfo',
    'url': 'http://www.espncricinfo.com'
  }, {
    'sport': 'soccer',
    'image': 'logo-deportes-fc',
    'url': 'http://www.espn.com.mx/futbol/'
  }, {
    'sport': 'rugby',
    'image': 'logo-deportes-scrum',
    'url': 'http://www.espn.com.mx/rugby/'
  }, {
    'sport': 'ncaaw',
    'image': 'espncom-presentadopor-espnw',
    'url': 'http://espnw.com'
  }, {
    'sport': 'ncw',
    'image': 'espncom-presentadopor-espnw',
    'url': 'http://espnw.com'
  }, {
    'sport': 'wnba',
    'image': 'espncom-presentadopor-espnw',
    'url': 'http://espnw.com'
  }, {
    'sport': 'womenbb',
    'image': 'espncom-presentadopor-espnw',
    'url': 'http://espnw.com'
  } ],
  'siteLogo': {
    'class': '',
    'featurePhone': {
      'name': 'espn-logo',
      'width': 45,
      'height': 11
    }
  },
  'meta': {
    'titleBranding': ' - ESPN',
    'description': 'ESPN lo último del mundo deportivo.',
    'defaultMetaImage': 'espn_red.png',
    'schema': {
      'name': 'ESPN'
    },
    'social': {
      'twitter': {
        'twitterId': '',
        'card': 'summary',
        'app_id_iphone': '317469184',
        'site': 'espn',
        'app_name_googleplay': 'ESPN',
        'app_id_googleplay': 'com.espn.score_center',
        'app_name_iphone': 'ESPN',
        'language': 'es'
      },
      'facebook': {
        'id': '116656161708917',
        'og_site_name': 'ESPN.com.mx',
        'locale': 'es_ES'
      }
    }
  },
  'shop': {
    'enabled': false
  },
  'sportReplacements': {},
  'uriRewrites': {
    'urls': {
      'toEdition': {
        '/futbol-americano/nfl/': '/futbol-americano/',
        '/beisbol/mlb/': '/beisbol/',
        '/basquetbol/nba/': '/basquetbol/'
      },
      'toEnglish': {}
    },
    'roots': {
      'toEdition': {},
      'toEnglish': {}
    },
    'pathSegments':{
      'reporte': 'report',
      'juego': 'game',
      'equipo': 'team',
      'plantel': 'roster',
      'estadisticas': 'stats',
      'calendario': 'schedule',
      'estadio': 'stadium',
      'profundidad': 'depth',
      'conversacion': 'conversation',
      'ficha': 'boxscore',
      'previa': 'preview',
      'partido': 'match',
      'jugadas': 'playbyplay',
      'cronica': 'recap',
      'fotos': 'photos',
      'duelo': 'matchup',
      'jugador': 'player',
      'posiciones': 'standings',
      'lesiones': 'injuries',
      'bateo': 'batting',
      'grilla': 'grid',
      'piloto': 'driver',
      'resultados': 'scoreboard',
      'liga': 'league',
      'ligas': 'leagues',
      'nota': 'story',
      'comentario': 'commentary',
      'alineacion': 'lineups',
      'estadisticas': 'matchstats',
      'jugador-estadisticas': 'playerstats',
      'medallas': 'medals',
      'deportes': 'sports',
      'deportistas': 'athletes',
      'lideres': 'leaderboard',
      'envivo': 'live',
      'ronda': 'rounds',
      'equipos': 'teams',
      'posicion': 'positions',
      'mejordisponible': 'bestavailable',
      'noticias': 'news',
      'noticiasdelequipo': 'teamnews',
      'fecha': 'date'
    },
    'paramKeys': {
      'juegoId': 'gameId',
      'fecha': 'date',
      'equipo': 'team',
      'nombre': 'name',
      'partido': 'gameID',
      'liga': 'league',
      'tipodetemporada': 'seasontype',
      'ano': 'year',
      'semana': 'week',
      'deportes': 'discipline',
      'evento': 'event',
      'torneo': 'tournamentId',
      'deportista': 'athlete',
      'vista': 'view',
      'pais': 'country',
      'pagina': 'page',
      'continuo': 'continuous',
      'ronda': 'round',
      'posicion': 'position'
    },
    'paramValues': {
      'liga': 'league',
      'todo': 'all',
      'deportistas': 'athletes',
      'paises': 'countries'
    }
  },
  'betting': {
    'enabled': true,
    'provider': 'caliente',
    'game': {
      'enabled': false,
      'provider': 'caliente'
    }
  },
  'ticketProvider': null,
  'hasTickets': false,
  'showFavorites': true,
  'showInsider': false,
  'showWatch': false,
  'hideCategoryLinks': [
    600,
    1700
  ],
  'categorySettings': {
    'leagues': true,
    'athletes': true,
    'teams': true,
    'tags': true
  },
  'showFCContent': true,
  'showCricInfoContent': false,
  'cookieConsent': true,
  'scDeepLinking': true,
  'allowShortUrl': false,
  'allowPrintUrl': true,
  'allowUserAccountManagement': true,
  'nowFeed': false,
  'searchUrl': 'http://buscar.espn.com/',
  'gameSettings': {
    'topEventsId': 3466354,
    'promotedSoccerLeaguesCeId': 3466584,
    'showBroadcast': false
  },
  'fallback': {
    'baseball': 'espn-es-us-baseball-index',
    'basketball': 'espn-es-us-basketball-index',
    'boxing': 'espn-es-us-boxing-index',
    'ciclismo': 'espn-es-co-ciclismo-index',
    'espn-run': 'espn-es-ar-espn-run-index',
    'esports': 'espn-es-us-esports-index',
    'espys': 'espn-es-us-espys-index',
    'f1': 'espn-es-mx-f1-index',
    'football': 'espn-es-us-football-index',
    'golf': 'espn-es-ar-golf-index',
    'los-angeles': 'espn-es-us-frontpage-index',
    'mlb': 'espn-es-us-baseball-index',
    'mlb-beisbolexperience': 'espn-es-us-mlb-beisbolexperience-index',
    'mma': 'espn-es-mx-mma-index',
    'motociclismo': 'espn-es-ar-motociclismo-index',
    'nacion-espn': 'espn-es-us-nacion-espn-index',
    'nba': 'espn-es-us-basketball-index',
    'nba-summerleague': 'espn-es-us-nba-summerleague-index',
    'nexoespn': 'espn-es-co-nexoespn-index',
    'nfl': 'espn-es-us-football-index',
    'oly-summer-archery': 'espn-es-mx-oly-summer-archery-index',
    'oly-summer-athletics': 'espn-es-mx-oly-summer-athletics-index',
    'oly-summer-badminton': 'espn-es-mx-oly-summer-badminton-index',
    'oly-summer-basketball': 'espn-es-mx-oly-summer-basketball-index',
    'oly-summer-boxing': 'espn-es-mx-oly-summer-boxing-index',
    'oly-summer-canoe': 'espn-es-mx-oly-summer-canoe-index',
    'oly-summer-cycling': 'espn-es-mx-oly-summer-cycling-index',
    'oly-summer-equestrian': 'espn-es-mx-oly-summer-equestrian-index',
    'oly-summer-fencing': 'espn-es-mx-oly-summer-fencing-index',
    'oly-summer-field-hockey': 'espn-es-mx-oly-summer-field-hockey-index',
    'oly-summer-golf': 'espn-es-mx-oly-summer-golf-index',
    'oly-summer-gymnastics': 'espn-es-mx-oly-summer-gymnastics-index',
    'oly-summer-handball': 'espn-es-mx-oly-summer-handball-index',
    'oly-summer-judo': 'espn-es-mx-oly-summer-judo-index',
    'oly-summer-modern-pentathlon': 'espn-es-mx-oly-summer-modern-pentathlon-index',
    'oly-summer-rowing': 'espn-es-mx-oly-summer-rowing-index',
    'oly-summer-rugby': 'espn-es-mx-oly-summer-rugby-index',
    'oly-summer-sailing': 'espn-es-mx-oly-summer-sailing-index',
    'oly-summer-shooting': 'espn-es-mx-oly-summer-shooting-index',
    'oly-summer-soccer': 'espn-es-mx-oly-summer-soccer-index',
    'oly-summer-swimming': 'espn-es-mx-oly-summer-swimming-index',
    'oly-summer-table-tennis': 'espn-es-mx-oly-summer-table-tennis-index',
    'oly-summer-taekwondo': 'espn-es-mx-oly-summer-taekwondo-index',
    'oly-summer-tennis': 'espn-es-mx-oly-summer-tennis-index',
    'oly-summer-triathlon': 'espn-es-mx-oly-summer-triathlon-index',
    'oly-summer-volleyball': 'espn-es-mx-oly-summer-volleyball-index',
    'oly-summer-water-polo': 'espn-es-mx-oly-summer-water-polo-index',
    'oly-summer-weightlifting': 'espn-es-mx-oly-summer-weightlifting-index',
    'oly-summer-wrestling': 'espn-es-mx-oly-summer-wrestling-index',
    'olympics': 'espn-es-mx-olympics-index',
    'other-sports': 'espn-es-us-other-sports-index',
    'panamerican': 'espn-es-us-panamerican-index',
    'poker': 'espn-es-ar-poker-index',
    'polo': 'espn-es-ar-polo-index',
    'rpm': 'espn-es-ar-rpm-index',
    'rugby': 'espn-es-ar-rugby-index',
    'serie-del-caribe': 'espn-es-us-serie-del-caribe-index',
    'soccer': 'espn-es-mx-soccer-index',
    'tennis': 'espn-es-ar-tennis-index',
    'world-baseball-classic': 'espn-es-us-world-baseball-classic-index',
    'wwe': 'espn-es-us-luchalibre-index',
    'x-games': 'espn-es-ar-x-games-index'
  },
  'editionAlert': {
    'enabled': true,
    'text': 'Has llegado a la edición de México. Quedarse en el sitio actual o ir a edición preferida.'
  },
  'feeds': {
    'googlenews': {
      'allowedContentTypes': [
        'TopStoryPackage',
        'BlogEntry',
        'HeadlineNews'
      ]
    }
  },
  'tier2NavIds': {
    'baseball': 3023264,
    'basketball': 2474875,
    'boxing': 2474907,
    'ciclismo': 2882281,
    'espn-run': 2507524,
    'esports': 2882075,
    'espys': 3121931,
    'f1': 2474769,
    'football': 2474884,
    'golf': 2475240,
    'los-angeles': '',
    'mlb': 3023264,
    'mlb/beisbolexperience': 3044646,
    'mma': 2475264,
    'motociclismo': 3397504,
    'nacion-espn': 2652083,
    'nba': 2474875,
    'nba/summerleague': 3316630,
    'nexoespn': 2649285,
    'nfl': 2474884,
    'oly/summer/archery': 2475258,
    'oly/summer/athletics': 2475258,
    'oly/summer/badminton': 2475258,
    'oly/summer/basketball': 2475258,
    'oly/summer/boxing': 2475258,
    'oly/summer/canoe': 2475258,
    'oly/summer/cycling': 2475258,
    'oly/summer/equestrian': 2475258,
    'oly/summer/fencing': 2475258,
    'oly/summer/field-hockey': 2475258,
    'oly/summer/golf': 2475258,
    'oly/summer/gymnastics': 2475258,
    'oly/summer/handball': 2475258,
    'oly/summer/judo': 2475258,
    'oly/summer/modern-pentathlon': 2475258,
    'oly/summer/rowing': 2475258,
    'oly/summer/rugby': 2475258,
    'oly/summer/sailing': 2475258,
    'oly/summer/shooting': 2475258,
    'oly/summer/soccer': 2475258,
    'oly/summer/swimming': 2475258,
    'oly/summer/table-tennis': 2475258,
    'oly/summer/taekwondo': 2475258,
    'oly/summer/tennis': 2475258,
    'oly/summer/triathlon': 2475258,
    'oly/summer/volleyball': 2475258,
    'oly/summer/water-polo': 2475258,
    'oly/summer/weightlifting': 2475258,
    'oly/summer/wrestling': 2475258,
    'olympics': 2475258,
    'other-sports': 2475272,
    'panamerican': 2507636,
    'poker': 2506302,
    'polo': 2511033,
    'rpm': 2474747,
    'rugby': 2474293,
    'serie-del-caribe': 2955159,
    'soccer': 2487614,
    'tennis': 2474261,
    'world-baseball-classic': 2978462,
    'wwe': 2946192,
    'x-games': 2475269
  },
  'tier3NavIds': {
    'clubhouse': {
      'nfl': 2520032,
      'mlb': 2523552,
      'nba': 2525379,
      'soccer': 2525397
    }
  },
  'indexAutoStart': false,
  'useMongo': true,
  'activeSite': true,
  'countries': [ {
    'name': 'Spain',
    'country-code': 'es',
    'showHreflang': true
  } ],
  'reactOverride': {
    'cricket' : {
      'scores' : true
    }
  }
}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/config/spanish/spain.js